module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "Title ParaOverride-1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Praise for WHEN YOU WENT AWAY")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“Lou Aronica writes with deep sensitivity of the power of love to transform and heal in the face of overwhelming tragedy. A lovely read.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise-att"
  }, [_vm._v("—#1 "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("New York Times ")]), _vm._v("bestselling author Susan Wiggs")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“Nicholas Sparks fans will rejoice to hear there’s a new male author on the scene who writes beautifully about love and emotionally charged relationships. Tears of sadness and joy go hand in hand in this immensely satisfying story. Outstanding!”")]), _vm._v(" "), _c('p', {
    staticClass: "praise-att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("T Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“A gem. I couldn’t put it down. The characters are people I’d like to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise-att"
  }, [_vm._v("—Peggy Webb, author of the Southern Cousins Mystery Series")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When You Went Away")]), _vm._v(" is a very powerful tale full of laughter, tears, and romantic moments that keep you enthralled with the authors voice. I think every reader will fall a little in love with both this outstanding author as well as this amazing character!”")]), _vm._v(" "), _c('p', {
    staticClass: "praise-att"
  }, [_vm._v("—Coffee Time Romance")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“I truly loved this story. It is so well-written that it’s hard to keep yourself separate from the fictional characters. I absolutely recommend this book and plan to read every other work written by this author. Triple-A reading!”")]), _vm._v(" "), _c('p', {
    staticClass: "praise-att"
  }, [_vm._v("—Fresh Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "praise"
  }, [_vm._v("“"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When You Went Away ")]), _vm._v("really surprised me with how much I enjoyed reading this book. Gerry and Reese stole a place in my heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "praise-att"
  }, [_vm._v("—Cheryl’s Book Nook")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11e2f9da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/When_You_Went_Away.vue
// module id = 57
// module chunks = 0